"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENG_COUNTRIES = exports.SUPPORTED_COUNTRY_ISO = exports.DYNATA_TRANSLATION_KEYS = exports.DYNATA_NA_VALUE = exports.DYNATA_QVALUE = exports.BUILT_IN_TARGET_QVALUE = void 0;
var BUILT_IN_TARGET_QVALUE;
(function (BUILT_IN_TARGET_QVALUE) {
    BUILT_IN_TARGET_QVALUE["DIVERSITY_SINGLE"] = "in.nexxt/qvalue/nexxt/diversity";
    BUILT_IN_TARGET_QVALUE["DIVERSITY_INTERLOCK"] = "in.nexxt/qvalue/nexxt/diversity_interlock";
    BUILT_IN_TARGET_QVALUE["DIVERSITY_INTERLOCK_GROUP_1"] = "in.nexxt/qvalue/nexxt/diversity_interlock_1";
    BUILT_IN_TARGET_QVALUE["DIVERSITY_INTERLOCK_GROUP_2"] = "in.nexxt/qvalue/nexxt/diversity_interlock_2";
    BUILT_IN_TARGET_QVALUE["DIVERSITY_INTERLOCK_GROUP_3"] = "in.nexxt/qvalue/nexxt/diversity_interlock_3";
    BUILT_IN_TARGET_QVALUE["DIVERSITY_INTERLOCK_GROUP_4"] = "in.nexxt/qvalue/nexxt/diversity_interlock_4";
    BUILT_IN_TARGET_QVALUE["DIVERSITY_INTERLOCK_GROUP_5"] = "in.nexxt/qvalue/nexxt/diversity_interlock_5";
    BUILT_IN_TARGET_QVALUE["AGE"] = "in.nexxt/qvalue/nexxt/age";
})(BUILT_IN_TARGET_QVALUE = exports.BUILT_IN_TARGET_QVALUE || (exports.BUILT_IN_TARGET_QVALUE = {}));
var DYNATA_QVALUE;
(function (DYNATA_QVALUE) {
    DYNATA_QVALUE["GENDER"] = "in.nexxt/qvalue/dynata/11";
    DYNATA_QVALUE["AGE"] = "in.nexxt/qvalue/dynata/13";
    DYNATA_QVALUE["HHR"] = "in.nexxt/qvalue/dynata/313441";
    DYNATA_QVALUE["RACE_ETHNICITY_US"] = "in.nexxt/qvalue/dynata/433438";
    DYNATA_QVALUE["LANGUAGE_FLUENCY"] = "in.nexxt/qvalue/dynata/7259331";
    DYNATA_QVALUE["HHC"] = "in.nexxt/qvalue/dynata/12369258";
    DYNATA_QVALUE["EMPLOYMENT_STATUS"] = "in.nexxt/qvalue/dynata/12370140";
    DYNATA_QVALUE["SEXUAL_ORIENTATION"] = "in.nexxt/qvalue/dynata/12375035";
    DYNATA_QVALUE["NUMBER_IN_HOUSEHOLD"] = "in.nexxt/qvalue/dynata/12375852";
    DYNATA_QVALUE["HOUSEHOLD_GROSS_INCOME"] = "in.nexxt/qvalue/dynata/12376682";
    DYNATA_QVALUE["RACE_ETHNICITY"] = "in.nexxt/qvalue/dynata/12376912";
    DYNATA_QVALUE["MARITAL_STATUS"] = "in.nexxt/qvalue/dynata/12377213";
    DYNATA_QVALUE["EDUCATION"] = "in.nexxt/qvalue/dynata/12377399";
    DYNATA_QVALUE["GEO_US"] = "in.nexxt/qvalue/dynata/12368356";
    DYNATA_QVALUE["GEO_CA"] = "in.nexxt/qvalue/dynata/12377466";
    DYNATA_QVALUE["GEO_AU"] = "in.nexxt/qvalue/dynata/12369204";
    DYNATA_QVALUE["GEO_GB"] = "in.nexxt/qvalue/dynata/12374972";
    DYNATA_QVALUE["GEO_NZ"] = "in.nexxt/qvalue/dynata/12376511";
    DYNATA_QVALUE["VEHICLES_IN_HOUSEHOLD"] = "in.nexxt/qvalue/dynata/12369437";
    DYNATA_QVALUE["PRIMARY_VEHICLES"] = "in.nexxt/qvalue/dynata/12372713";
    DYNATA_QVALUE["FINANCIAL_INSURANCE_PRODUCT"] = "in.nexxt/qvalue/dynata/1900666";
    DYNATA_QVALUE["FINANCIAL_SERVICES"] = "in.nexxt/qvalue/dynata/1901683";
    DYNATA_QVALUE["FINANCIAL_PRODUCTS"] = "in.nexxt/qvalue/dynata/12368241";
    DYNATA_QVALUE["HOUSEHOLD_INVESTABLE_ASSETS"] = "in.nexxt/qvalue/dynata/12377335";
    DYNATA_QVALUE["FOOD_PRODUCT_PURCHASE"] = "in.nexxt/qvalue/dynata/7105107";
    DYNATA_QVALUE["NON_ALCOHOLIC_BEVERAGES"] = "in.nexxt/qvalue/dynata/12372652";
    DYNATA_QVALUE["PERSONAL_CARE_PRODUCTS"] = "in.nexxt/qvalue/dynata/1493607";
    DYNATA_QVALUE["HOUSEHOLD_APPLICANCE_OWNED"] = "in.nexxt/qvalue/dynata/12370035";
    DYNATA_QVALUE["PETS_IN_HOUSEHOLD"] = "in.nexxt/qvalue/dynata/12370350";
    DYNATA_QVALUE["HOME_TYPE"] = "in.nexxt/qvalue/dynata/12373492";
    DYNATA_QVALUE["ENGINE_TYPE"] = "in.nexxt/qvalue/dynata/12370456";
    DYNATA_QVALUE["NUM_CHILDREN"] = "in.nexxt/qvalue/dynata/12371309";
    DYNATA_QVALUE["INSURANCE_PRODUCTS_GB"] = "in.nexxt/qvalue/dynata/12374731";
    DYNATA_QVALUE["PERSONAL_GROSS_INCOME"] = "in.nexxt/qvalue/dynata/12376216";
    DYNATA_QVALUE["SOCIAL_GRADE_GB"] = "in.nexxt/qvalue/dynata/12377748";
})(DYNATA_QVALUE = exports.DYNATA_QVALUE || (exports.DYNATA_QVALUE = {}));
exports.DYNATA_NA_VALUE = (_a = {},
    _a[DYNATA_QVALUE.LANGUAGE_FLUENCY] = 1051,
    _a[DYNATA_QVALUE.FINANCIAL_INSURANCE_PRODUCT] = 999,
    _a[DYNATA_QVALUE.FINANCIAL_SERVICES] = 999,
    _a[DYNATA_QVALUE.FINANCIAL_PRODUCTS] = 51,
    _a[DYNATA_QVALUE.FOOD_PRODUCT_PURCHASE] = 9,
    _a[DYNATA_QVALUE.NON_ALCOHOLIC_BEVERAGES] = 22,
    _a[DYNATA_QVALUE.PERSONAL_CARE_PRODUCTS] = 999,
    _a[DYNATA_QVALUE.HOUSEHOLD_APPLICANCE_OWNED] = 17,
    _a[DYNATA_QVALUE.PETS_IN_HOUSEHOLD] = 11,
    _a);
exports.DYNATA_TRANSLATION_KEYS = (_b = {},
    _b[DYNATA_QVALUE.AGE] = 'QUESTION.PANEL.DYNATA.AGE_GROUP',
    _b[DYNATA_QVALUE.GENDER] = 'QUESTION.PANEL.DYNATA.GENDER',
    _b[DYNATA_QVALUE.HHR] = 'QUESTION.PANEL.DYNATA.HOUSEHOLD_ROLE',
    _b[DYNATA_QVALUE.RACE_ETHNICITY_US] = 'QUESTION.PANEL.DYNATA.RACE_ETHNNICITY',
    _b[DYNATA_QVALUE.PERSONAL_CARE_PRODUCTS] = 'QUESTION.PANEL.DYNATA.PERSONAL_CARE_PRODUCTS',
    _b[DYNATA_QVALUE.FINANCIAL_INSURANCE_PRODUCT] = 'QUESTION.PANEL.DYNATA.FINANCIAL_INSURANCE_PRODUCTS',
    _b[DYNATA_QVALUE.FINANCIAL_SERVICES] = 'QUESTION.PANEL.DYNATA.FINANCIAL_SERVICES',
    _b[DYNATA_QVALUE.FOOD_PRODUCT_PURCHASE] = 'QUESTION.PANEL.DYNATA.FOOD_PRODUCTS_PURCHASED_P3M',
    _b[DYNATA_QVALUE.LANGUAGE_FLUENCY] = 'QUESTION.PANEL.DYNATA.LANGUAGE_FLUENT',
    _b[DYNATA_QVALUE.FINANCIAL_PRODUCTS] = 'QUESTION.PANEL.DYNATA.FINANCIAL_PRODUCTS',
    _b[DYNATA_QVALUE.GEO_US] = 'QUESTION.PANEL.DYNATA.GEO',
    _b[DYNATA_QVALUE.GEO_AU] = 'QUESTION.PANEL.DYNATA.GEO',
    _b[DYNATA_QVALUE.GEO_CA] = 'QUESTION.PANEL.DYNATA.GEO',
    _b[DYNATA_QVALUE.HHC] = 'QUESTION.PANEL.DYNATA.HOUSEHOLD_CHILD',
    _b[DYNATA_QVALUE.VEHICLES_IN_HOUSEHOLD] = 'QUESTION.PANEL.DYNATA.VEHICLES_IN_HOUSEHOLD',
    _b[DYNATA_QVALUE.HOUSEHOLD_APPLICANCE_OWNED] = 'QUESTION.PANEL.DYNATA.HOUSEHOLD_APPLIANCES_OWNED',
    _b[DYNATA_QVALUE.EMPLOYMENT_STATUS] = 'QUESTION.PANEL.DYNATA.EMPLOYMENT_STATUS',
    _b[DYNATA_QVALUE.PETS_IN_HOUSEHOLD] = 'QUESTION.PANEL.DYNATA.PETS_IN_HOUSEHOLD',
    _b[DYNATA_QVALUE.ENGINE_TYPE] = 'QUESTION.PANEL.DYNATA.ENGINE_TYPE',
    _b[DYNATA_QVALUE.NUM_CHILDREN] = 'QUESTION.PANEL.DYNATA.NUM_CHILDREN',
    _b[DYNATA_QVALUE.NON_ALCOHOLIC_BEVERAGES] = 'QUESTION.PANEL.DYNATA.NON_ALCOHOLIC_BEVERAGES',
    _b[DYNATA_QVALUE.PRIMARY_VEHICLES] = 'QUESTION.PANEL.DYNATA.PRIMARY_VEHICLE_CATEGORY',
    _b[DYNATA_QVALUE.HOME_TYPE] = 'QUESTION.PANEL.DYNATA.HOME_TYPE_OF_STRUCTURE',
    _b[DYNATA_QVALUE.INSURANCE_PRODUCTS_GB] = 'QUESTION.PANEL.DYNATA.INSURANCE_PRODUCT',
    _b[DYNATA_QVALUE.GEO_GB] = 'QUESTION.PANEL.DYNATA.GEO',
    _b[DYNATA_QVALUE.GEO_NZ] = 'QUESTION.PANEL.DYNATA.GEO',
    _b[DYNATA_QVALUE.SEXUAL_ORIENTATION] = 'QUESTION.PANEL.DYNATA.SEXUAL_ORIENTATION',
    _b[DYNATA_QVALUE.NUMBER_IN_HOUSEHOLD] = 'QUESTION.PANEL.DYNATA.NUMBER_IN_HOUSEHOLD',
    _b[DYNATA_QVALUE.PERSONAL_GROSS_INCOME] = 'QUESTION.PANEL.DYNATA.PERSONAL_GROSS_INCOME',
    _b[DYNATA_QVALUE.HOUSEHOLD_GROSS_INCOME] = 'QUESTION.PANEL.DYNATA.GROSS_INCOME_HOUSEHOLD',
    _b[DYNATA_QVALUE.RACE_ETHNICITY] = 'QUESTION.PANEL.DYNATA.RACE_ETHNNICITY',
    _b[DYNATA_QVALUE.MARITAL_STATUS] = 'QUESTION.PANEL.DYNATA.MARITAL_STATUS',
    _b[DYNATA_QVALUE.HOUSEHOLD_INVESTABLE_ASSETS] = 'QUESTION.PANEL.DYNATA.INVESTABLE_ASSETS',
    _b[DYNATA_QVALUE.EDUCATION] = 'QUESTION.PANEL.DYNATA.EDUCATION',
    _b[DYNATA_QVALUE.SOCIAL_GRADE_GB] = 'QUESTION.PANEL.DYNATA.SOCIAL_GRACE' // need to add i18n
,
    _b);
var SUPPORTED_COUNTRY_ISO;
(function (SUPPORTED_COUNTRY_ISO) {
    SUPPORTED_COUNTRY_ISO["CA"] = "CA";
    SUPPORTED_COUNTRY_ISO["US"] = "US";
    SUPPORTED_COUNTRY_ISO["AU"] = "AU";
    SUPPORTED_COUNTRY_ISO["GB"] = "GB";
    SUPPORTED_COUNTRY_ISO["NZ"] = "NZ";
})(SUPPORTED_COUNTRY_ISO = exports.SUPPORTED_COUNTRY_ISO || (exports.SUPPORTED_COUNTRY_ISO = {}));
exports.ENG_COUNTRIES = [
    SUPPORTED_COUNTRY_ISO.CA,
    SUPPORTED_COUNTRY_ISO.US,
    SUPPORTED_COUNTRY_ISO.AU,
    SUPPORTED_COUNTRY_ISO.NZ,
    SUPPORTED_COUNTRY_ISO.GB
];
//# sourceMappingURL=types.js.map